var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_167_478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9985 9.99902H11.3322C10.9786 9.99902 10.6395 10.1395 10.3895 10.3895C10.1395 10.6395 9.99902 10.9786 9.99902 11.3322V20.6647C9.99902 21.0183 10.1395 21.3574 10.3895 21.6074C10.6395 21.8575 10.9786 21.9979 11.3322 21.9979H20.6647C21.0183 21.9979 21.3574 21.8575 21.6074 21.6074C21.8575 21.3574 21.9979 21.0183 21.9979 20.6647V15.9985",
    stroke: "#2F91F8",
    strokeWidth: 1.33321,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2478 9.74914C20.513 9.48394 20.8727 9.33496 21.2477 9.33496C21.6227 9.33496 21.9824 9.48394 22.2476 9.74914C22.5128 10.0143 22.6618 10.374 22.6618 10.749C22.6618 11.1241 22.5128 11.4838 22.2476 11.749L16.2395 17.7577C16.0812 17.9159 15.8857 18.0317 15.6709 18.0944L13.7557 18.6543C13.6984 18.671 13.6376 18.6721 13.5797 18.6572C13.5218 18.6424 13.469 18.6123 13.4267 18.57C13.3845 18.5278 13.3544 18.4749 13.3395 18.4171C13.3247 18.3592 13.3257 18.2984 13.3424 18.241L13.9024 16.3259C13.9654 16.1113 14.0814 15.9159 14.2397 15.7579L20.2478 9.74914Z",
    stroke: "#2F91F8",
    strokeWidth: 1.33321,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_167_478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9985,
    height: 15.9985,
    fill: "white",
    transform: "translate(7.99902 7.99927)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b38b23e431ce27b0fcb8e90a43a2c100.svg";
export { ForwardRef as ReactComponent };